import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { withStyles } from '@material-ui/core/styles';

import SideBadge from 'components/SideBadge/SideBadge';
import ProjectListItem from 'scenes/Projects/components/ProjectListItem';
import TimerContent from './components/TimerContent';
import { mdiTimerOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { selectLatestActiveProjectsForTimerDrawer } from 'store/projects/selectors/projectsRecords.selectors';
import {
  selectIsClockedInRecordsLoading,
  selectPersonalClockedInWorkRecords,
} from 'store/records/selectors/records.selectors';

const mapStateToProps = (state) => ({
  user: state.root.user,
  inRecords: selectPersonalClockedInWorkRecords(state),
  inRecordsLoading: selectIsClockedInRecordsLoading(state),
  lastProjects: selectLatestActiveProjectsForTimerDrawer(state),
});

const styles = (theme) => ({
  root: {
    display: 'inherit',
    // '&:hover': {
    //   color: 'hsla(195,75%,25%,1)',
    //   [theme.breakpoints.up('sm')]: {
    //     color: 'hsla(195,75%,25%,0.75)',
    //   },
    // },
  },
  rootOpen: {
    color: 'hsla(195,75%,25%,1)',
    [theme.breakpoints.up('sm')]: {
      color: 'hsla(195,75%,25%,0.75)',
    },
  },
  iconButton: {
    height: 40,
    padding: 0,
    width: 40,
    [theme.breakpoints.up('sm')]: {
      margin: '0 4px',
    },
  },
  // Mirrors the Projects-page mobile list drawer paper
  // (src/scenes/Projects/Projects.js) — same background, padding and width.
  drawerPaper: {
    width: '85vw',
    maxWidth: 360,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1),
    paddingTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  // Separates clocked-in projects from the rest, like the source list's
  // employer/rest divider (src/scenes/Projects/ProjectsList.jsx).
  divider: {
    marginBottom: theme.spacing(1),
  },
});

class TimerButton extends Component {
  state = {
    open: false,
    clockOutDialog: false,
    recordDialogOpen: false,
    record: {},
    project: {},
    loading: false,
    profilePictureRequired: false,
    clockInTargetProject: null,
  };

  componentDidMount() {
    // ProjectListItem navigates internally (no onCloseParent callback), so close
    // the drawer whenever the route changes while it's open. Clock-in does not
    // navigate, so the drawer stays open during clock-in — matching prior behavior.
    this.unlistenHistory = this.props.history.listen(() => {
      if (this.state.open) {
        this.handleClose();
      }
    });
  }

  componentWillUnmount() {
    if (this.unlistenHistory) {
      this.unlistenHistory();
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, inRecords, inRecordsLoading, lastProjects } = this.props;

    const { open } = this.state;

    const renderProject = (item) => (
      <ProjectListItem
        key={item.id}
        project={item}
        type="project"
        hideExpandButton
        showRecordEditButton
      />
    );

    const timerContent = (
      <Translation ns={['common']}>
        {(t) => (
          <TimerContent
            onClose={this.handleClose}
            title={t('common.latest_projects')}
          >
            {lastProjects.clockedIn.map(renderProject)}
            {lastProjects.clockedIn.length > 0 &&
              lastProjects.rest.length > 0 && (
                <Divider className={classes.divider} />
              )}
            {lastProjects.rest.map(renderProject)}
          </TimerContent>
        )}
      </Translation>
    );

    const badge = inRecordsLoading ? (
      <SideBadge badgeContent={<CircularProgress color="inherit" size={12} />}>
        {/* <TimerIcon /> */}
        <Icon path={mdiTimerOutline} size={1} />
      </SideBadge>
    ) : (
      <SideBadge
        badgeContent={inRecords.length}
        color="secondary"
        invisible={inRecords.length === 0}
      >
        <Icon path={mdiTimerOutline} size={1} />
      </SideBadge>
    );

    return (
      <div className={clsx(classes.root, open && classes.rootOpen)}>
        <IconButton
          className={classes.iconButton}
          color="inherit"
          onClick={this.handleOpen}
          title="Notifications"
        >
          {badge}
        </IconButton>
        <SwipeableDrawer
          anchor="right"
          classes={{ paper: classes.drawerPaper }}
          open={open}
          onOpen={this.handleOpen}
          onClose={this.handleClose}
        >
          {timerContent}
        </SwipeableDrawer>
      </div>
    );
  }
}

TimerButton.defaultProps = {
  classes: {},
  data: {},
  inRecords: [],
};

TimerButton.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  inRecords: PropTypes.array.isRequired,
  inRecordsLoading: PropTypes.bool.isRequired,
  lastProjects: PropTypes.shape({
    clockedIn: PropTypes.array.isRequired,
    rest: PropTypes.array.isRequired,
  }).isRequired,
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const TimerButtonCompose = connect(mapStateToProps)(TimerButton);
export default withRouter(
  withStyles(styles, { withTheme: true })(TimerButtonCompose)
);
